export function buildForgotPasswordUrl(url, email, accountId) {
  const [path, query = ""] = String(url).split("?");
  const params = new URLSearchParams(query);

  if (email) params.set("email", email);
  if (accountId) params.set("account_id", accountId);

  const search = params.toString();

  return search ? `${path}?${search}` : path;
}
